<script lang="ts">
	import '../app.css'
	import type { LayoutData } from './$types'
	import { onMount } from 'svelte'
	import { invalidate } from '$app/navigation'
	import { SvelteToast } from '@zerodevx/svelte-toast'
	import { TOAST_THEME } from '$lib/constants/toast-theme'
	import { PUBLIC_GTM_ID } from '$env/static/public'
	interface Props {
		data: LayoutData
		children?: import('svelte').Snippet
	}

	let { data, children }: Props = $props()

	let { supabase, session } = $derived(data)

	onMount(() => {
		const {
			data: { subscription }
		} = supabase.auth.onAuthStateChange((_, _session) => {
			if (_session?.expires_at !== session?.expires_at) {
				invalidate('supabase:auth')
			}
		})

		return () => subscription.unsubscribe()
	})
</script>

<svelte:head>
	<script>
		const GTM_ID = location.host === 'tickerdata.com' ? 'GTM-NZF58LDJ' : ''
		;(function (w, d, s, l, i) {
			w[l] = w[l] || []
			w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
			var f = d.getElementsByTagName(s)[0],
				j = d.createElement(s),
				dl = l != 'dataLayer' ? '&l=' + l : ''
			j.async = true
			j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
			f.parentNode.insertBefore(j, f)
		})(window, document, 'script', 'dataLayer', GTM_ID)
	</script>
</svelte:head>
<!-- Google Tag Manager (noscript) -->
<noscript
	><iframe
		src={`https://www.googletagmanager.com/ns.html?id=${PUBLIC_GTM_ID}`}
		height="0"
		width="0"
		style="display: none; visibility: hidden"
	></iframe></noscript
>
<!-- End Google Tag Manager (noscript) -->
<section class="font-manrope text-slate-800">
	{@render children?.()}
</section>

<SvelteToast
	options={{
		theme: TOAST_THEME
	}}
/>
